import { useEffect, useState } from 'react';
import axios from "axios";
import logo from '../images/logo_text.png';
import TryButton from '../button/TryButton';

export default function UsersListPage() {
    const token = window.localStorage.getItem("token");

    const [users, setUsers] = useState([]);

    // UseEffects

    useEffect(() => {
        // Fetch users from the backend API
        axios.get(process.env.REACT_APP_API_URL + `/auth`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setUsers(res.data);

            console.log("Fetched users data:", res.data);
        }).catch(err => {
            console.error("Error fetching selected child data:", err);
        });
    }, []);


    return (
        <div className="page no-padding-top">
            <div className="d-flex mx-md-5 py-3 text-md-start justify-content-between">
                <a href="/">
                    <img src={logo} className="logo-search" alt="Logo" />
                </a>
                <TryButton className='me-3 my-3'
                    onClick={() => window.history.back()}
                    text="Revenire" />
            </div>

            <h2 className='text-center my-4'>Lista utilizatorilor</h2>

            <div className='container, d-flex flex-wrap justify-content-center'>
                {users.map((user, index) => (
                    <a key={index} className="border-4 rounded-5 
                            border-danger border
                         m-3 p-3 text-center text-decoration-none text-light"
                        href={`/users/${user._id}`} style={{ width: '18rem' }}
                    >
                        <h5>{user.name}</h5>
                        <p>Tip: {(() => {
                            switch (user.type) {
                                case 'OWNER':
                                    return 'Proprietar';
                                case 'ADMIN':
                                    return 'Administrator';
                                case 'COACH':
                                    return 'Antrenor';
                                default:
                                    return user.type;
                            }
                        })()}</p>
                    </a>
                ))}
            </div>
        </div>
    )
}